<template>
  <h4 class="Cart__Title h4">{{ store.terms.empty.title }}</h4>
  <a class="button button--tertiary-a Cart__EmptyBtn" :href="store.terms.empty.cta_url" data-ht-element="empty-cart-cta-homepage">
    {{ store.terms.empty.cta_text }}
  </a>
  <a class="button button--tertiary-a Cart__EmptyBtn" :href="store.terms.empty.alt_cta_url" data-ht-element="empty-cart-cta-quiz">
    {{ store.terms.empty.alt_cta_text }}
  </a>
</template>

<script setup>
import { useCartStore } from './Composables/Store';

const store = useCartStore();
</script>
